<template>
    <div class="designerpage">

        <div class="barbican-designer-side-banner"></div>

        <barbican-designer-question-door-range
          :fabricator="fabricator"
          :ranges="ranges"
          :reference_on="reference_on"
          v-model:target="door.attr.door_range"
          :defaults="defaults()"
          title="Choose a Door Range"
          v-if="range_panel_required"
        ></barbican-designer-question-door-range>

        <designer-question-panel-category-with-thumbnails
            v-if="door.attr.door_range === 137"
            :fabricator="fabricator"
            :secured-by-design="door.attr.secured_by_design"
            :door-range="door.attr.door_range"
            :target.sync="door.attr.category"
            :modifier_class="'_wide'"
        ></designer-question-panel-category-with-thumbnails>

        <wb-designer-question-select-door :door-range="door.attr.door_range"
                                          :fabricator="fabricator"
                                          :secured-by-design="door.attr.secured_by_design"
                                          :category="door.attr.category"
                                          v-model:target="door.attr.slab"></wb-designer-question-select-door>

        <div class="designeroption">
            <designer-question-frame-material :fabricator="fabricator"
                                                 :slab="door.attr.slab"
                                                 v-model:target="door.attr.frame_material"></designer-question-frame-material>
        </div>

        <div>
            <wb-designer-question-select-frame-style :fabricator="fabricator" :frame-material="door.attr.frame_material"
                                                     :is-firedoor="is_firedoorrange"
                                                     v-model:target="door.attr.frame_style"
                                                     v-if="!is_french"></wb-designer-question-select-frame-style>
            <wb-french-designer-question-select-frame-style :fabricator="fabricator"
                                                            :frame-material="door.attr.frame_material"
                                                            :is-firedoor="is_firedoorrange"
                                                            v-model:target="door.attr.frame_style"
                                                            v-if="is_french"></wb-french-designer-question-select-frame-style>
        </div>

        <barbican-designer-question-colour-range
          title="Colour Ranges"
          :fabricator="fabricator"
          :type-range="door.attr.door_range"
          v-model:target="door.attr.colour_range"
        ></barbican-designer-question-colour-range>

        <div class="designeroption" data-designer-component-id="door_colour">
            <h3>Choose Your Door Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#dc-tabs-1">External Colour</a></li>
                    <li><a href="#dc-tabs-2">Internal Colour</a></li>
                </ul>
                <div id="dc-tabs-1">
                    <wb-designer-question-door-colour-external
                      :fabricator="fabricator"
                      :slab="door.attr.slab"
                      :door-range="door.attr.door_range"
                      :colour-range="door.attr.colour_range"
                      v-model:target="door.attr.external_colour"
                    ></wb-designer-question-door-colour-external>

                    <designer-question-ral-colour :colour-id="door.attr.external_colour" :fabricator="fabricator"
                                                  v-model:target="door.attr.external_colour_ral"
                                                  title="External Door Colour"></designer-question-ral-colour>
                </div>
                <div id="dc-tabs-2">
                    <futureproducts-designer-question-door-colour-internal
                      :external-colour="door.attr.external_colour"
                      :fabricator="fabricator"
                      :slab="door.attr.slab"
                      :door-range="door.attr.door_range"
                      :colour-range="door.attr.colour_range"
                      v-model:target="door.attr.door_colour_internal"
                    ></futureproducts-designer-question-door-colour-internal>

                    <designer-question-ral-colour :colour-id="door.attr.door_colour_internal" :fabricator="fabricator"
                                                  v-model:target="door.attr.door_colour_internal_ral"
                                                  title="Internal Door Colour"></designer-question-ral-colour>
                </div>
            </div>
        </div>

        <div class="designeroption" data-designer-component-id="frame_colour">
            <h3>Pick Your Frame Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#tabs-1">External Colour</a></li>
                    <li><a href="#tabs-2">Internal Colour</a></li>
                </ul>
                <div id="tabs-1">
                    <demo-designer-question-frame-colour-external
                        :fabricator="fabricator"
                        :frame-material="door.attr.frame_material"
                        :slab="door.attr.slab"
                        v-model:target="door.attr.frame_colour_external"
                    ></demo-designer-question-frame-colour-external>

                    <designer-question-ral-colour :colour-id="door.attr.frame_colour_external" :fabricator="fabricator"
                                                  v-model:target="door.attr.frame_colour_external_ral"
                                                  title="External Frame Colour"></designer-question-ral-colour>
                </div>
                <div id="tabs-2">
                    <demo-designer-question-frame-colour-internal
                        :fabricator="fabricator"
                        :frame-colour-external="door.attr.frame_colour_external"
                        :frame-material="door.attr.frame_material"
                        :slab="door.attr.slab"
                        v-model:target="door.attr.frame_colour_internal"
                    ></demo-designer-question-frame-colour-internal>

                    <designer-question-ral-colour :colour-id="door.attr.frame_colour_internal" :fabricator="fabricator"
                                                  v-model:target="door.attr.frame_colour_internal_ral"
                                                  title="Internal Frame Colour"></designer-question-ral-colour>
                </div>
            </div>
        </div>

        <div>
            <wb-designer-question-secured-by-design :fabricator="fabricator" v-model:target="door.attr.secured_by_design"
                                                    v-if="!no_sbd" v-show="false"></wb-designer-question-secured-by-design>

            <designer-question-door-glass-laminated :fabricator="fabricator"
                                                       :frame-style="door.attr.frame_style"
                                                       :is-firedoor="is_firedoorrange"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :side-panels="door.attr.side_panels"
                                                       :slab="door.attr.slab"
                                                       :door_range="door.attr.door_range"
                                                       v-model:target="door.attr.laminated_glass"
                                                       title="Laminated Glass:"></designer-question-door-glass-laminated>
        </div>

        <div>
            <wb-designer-question-glass-design :door-range="door.attr.door_range"
                                               :fabricator="fabricator"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :slab="door.attr.slab"
                                               v-model:target="door.attr.glass_design"></wb-designer-question-glass-design>

            <designer-question-glass-text :glass-design="door.attr.glass_design"
                                          v-model:target="door.attr.glass_text"></designer-question-glass-text>
        </div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                   :glass-design="door.attr.glass_design"
                                                   :slab="door.attr.slab"
                                                   v-model:target="door.attr.glass_backing_design"></wb-designer-question-glass-backing-design>

        <futureproducts-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                                  v-model:target="door.attr.side_panels"
                                                                  :door-range="door.attr.door_range"
                                                                  :frame-style="door.attr.frame_style"
                                                                  :frame-profile="door.attr.profile"
                                                                  :frame-material="door.attr.frame_material"
                                                                  :laminated-glass="door.attr.laminated_glass"
                                                                  :frame-colour-internal="door.attr.frame_colour_internal"
                                                                  :frame-colour-external="door.attr.frame_colour_external"
                                                                  :secured-by-design="door.attr.secured_by_design"
                                                                  :slab="door.attr.slab"
                                                                  :measurements.sync="door.attr.measurements"
                                                                  :cill="door.attr.cill"
                                                                  :threshold="door.attr.threshold"></futureproducts-designer-question-select-frame-sidepanels>

      <konic-doors-designer-question-collection-bottom-panel :fabricator="fabricator"
                                                             :title="'Select your bottom panel style'"
                                                             :question="'side_panel'"
                                                             v-model:target="door.attr.side_panels.lower_sidepanel_type"
                                                             :side-variant-left="door.attr.side_panels.left"
                                                             :side-variant-right="door.attr.side_panels.right"
      ></konic-doors-designer-question-collection-bottom-panel>

        <div class="designeroption" v-if="!is_french">
            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>
        </div>

        <div class="designeroption">
            <designer-question-opening-direction :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"></designer-question-opening-direction>
        </div>

        <div>
            <wb-designer-question-french-master :fabricator="fabricator" v-model:target="door.attr.french_master"
                                                title="Select Your Master Door"
                                                v-if="is_french"></wb-designer-question-french-master>
        </div>

        <barbican-designer-question-hardware-suite-selector
                v-if="!is_firedoorrange"
                :fabricator="fabricator"
                v-model:target="door.attr.suite"
                :door-range="door.attr.door_range"
                :slab="door.attr.slab"
                :secured-by-design="door.attr.secured_by_design"
                :opening-direction="door.attr.opening_direction"
                :profile="door.attr.profile"
        ></barbican-designer-question-hardware-suite-selector>

        <div>
            <!--<wb-designer-question-hardware-colour :door-range="door.attr.door_range"-->
                                                  <!--:fabricator="fabricator"-->
                                                  <!--:hardware-suite="door.attr.suite"-->
                                                  <!--:opening-direction="door.attr.opening_direction"-->
                                                  <!--:profile="door.attr.profile"-->
                                                  <!--:sbd="door.attr.secured_by_design"-->
                                                  <!--:slab="door.attr.slab"-->
                                                  <!--v-model:target="door.attr.hardware_colour"></wb-designer-question-hardware-colour>-->
            <wb-designer-question-hardware-colour-with-suite :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_colour"
                                                             :sbd="door.attr.secured_by_design"
                                                             :slab="door.attr.slab"
                                                             :hardware-suite="door.attr.suite"
                                                             :door-range="door.attr.door_range"
                                                             :profile="door.attr.profile"
                                                             :opening-direction="door.attr.opening_direction"></wb-designer-question-hardware-colour-with-suite>
        </div>
        <div>
            <wb-designer-question-hardware-handle-with-suite v-show="!is_firedoorrang" :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_handle"
                                                             :slab="door.attr.slab"
                                                             :secured-by-design="door.attr.secured_by_design"
                                                             :opening-direction="door.attr.opening_direction"
                                                             :hardware-colour="door.attr.hardware_colour"
                                                             :hardware-suite="door.attr.suite"
                                                             :door-range="door.attr.door_range"
                                                             :profile="door.attr.profile"></wb-designer-question-hardware-handle-with-suite>
            <!--<wb-designer-question-hardware-handle :door-range="door.attr.door_range" :fabricator="fabricator"-->
                                                  <!--:hardware-colour="door.attr.hardware_colour"-->
                                                  <!--:hardware-suite="door.attr.suite"-->
                                                  <!--:opening-direction="door.attr.opening_direction"-->
                                                  <!--:profile="door.attr.profile"-->
                                                  <!--:secured-by-design="door.attr.secured_by_design"-->
                                                  <!--:slab="door.attr.slab"-->
                                                  <!--v-model:target="door.attr.hardware_handle"-->
                                                  <!--v-show="is_firedoorrange || 1===1"></wb-designer-question-hardware-handle>-->
            <wb-designer-question-hardware-handle-slave-with-suite v-if="is_french" :fabricator="fabricator"
                                                                   title="Select Your Slave Handle"
                                                                   v-model:target="door.attr.hardware_handle_slave"
                                                                   :hardware-handle="door.attr.hardware_handle"
                                                                   :slab="door.attr.slab"
                                                                   :secured-by-design="door.attr.secured_by_design"
                                                                   :opening-direction="door.attr.opening_direction"
                                                                   :hardware-colour="door.attr.hardware_colour"
                                                                   :hardware-suite="door.attr.suite"
                                                                   :door-range="door.attr.door_range"
                                                                   :profile="door.attr.profile"></wb-designer-question-hardware-handle-slave-with-suite>
            <!--<wb-designer-question-hardware-handle-slave :door-range="door.attr.door_range" :fabricator="fabricator"-->
                                                        <!--:hardware-colour="door.attr.hardware_colour"-->
                                                        <!--:hardware-handle="door.attr.hardware_handle"-->
                                                        <!--:hardware-suite="door.attr.suite"-->
                                                        <!--:opening-direction="door.attr.opening_direction"-->
                                                        <!--:profile="door.attr.profile"-->
                                                        <!--:secured-by-design="door.attr.secured_by_design"-->
                                                        <!--:slab="door.attr.slab"-->
                                                        <!--v-model:target="door.attr.hardware_handle_slave"-->
                                                        <!--title="Select Your Slave Handle"-->
                                                        <!--v-if="is_french"></wb-designer-question-hardware-handle-slave>-->

            <designer-question-hardware-handle-split-spindle :fabricator="fabricator"
                                                             :hardware-handle="door.attr.hardware_handle"
                                                             :slab="door.attr.slab"
                                                             v-model:target="door.attr.hardware_handle_split_spindle"></designer-question-hardware-handle-split-spindle>

            <designer-question-hardware-decorative-handle :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_decorative_handle"
                                                          :slab="door.attr.slab"
                                                          :hardware-colour="door.attr.hardware_colour"
                                                          :door-range="door.attr.door_range"></designer-question-hardware-decorative-handle>

            <designer-question-hardware-decorative-handle-position :fabricator="fabricator"
                                                                   v-model:target="door.attr.hardware_decorative_handle_pos"
                                                                   :slab="door.attr.slab"
                                                                   :frame-material="door.attr.frame_material"
                                                                   :hardware-decorative-handle="door.attr.hardware_decorative_handle"></designer-question-hardware-decorative-handle-position>
        </div>
        <div>
            <wb-designer-question-hardware-escutcheon :door-range="door.attr.door_range"
                                                      :fabricator="fabricator"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :profile="door.attr.profile"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :slab="door.attr.slab"
                                                      v-model:target="door.attr.hardware_escutcheon"></wb-designer-question-hardware-escutcheon>

            <wb-designer-question-hardware-escutcheon-position :door-range="door.attr.door_range"
                                                               :fabricator="fabricator"
                                                               :frame-material="door.attr.frame_material"
                                                               :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                               :slab="door.attr.slab"
                                                               v-model:target="door.attr.hardware_escutcheon_pos"></wb-designer-question-hardware-escutcheon-position>
        </div>

        <div v-if="is_stable">
            <wb-designer-question-hardware-escutcheon-stable :door-range="door.attr.door_range"
                                                             :fabricator="fabricator"
                                                             :hardware-colour="door.attr.hardware_colour"
                                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                             :hardware-handle="door.attr.hardware_handle"
                                                             :secured-by-design="door.attr.secured_by_design"
                                                             :slab="door.attr.slab"
                                                             v-model:target="door.attr.hardware_escutcheon_stable"
                                                             title="Stable Bottom Leaf Escutcheon"></wb-designer-question-hardware-escutcheon-stable>

            <wb-designer-question-hardware-escutcheon-stable-position :door-range="door.attr.door_range"
                                                                      :fabricator="fabricator"
                                                                      :frame-material="door.attr.frame_material"
                                                                      :hardware-escutcheon="door.attr.hardware_escutcheon_stable"
                                                                      :slab="door.attr.slab"
                                                                      v-model:target="door.attr.hardware_escutcheon_stable_pos"></wb-designer-question-hardware-escutcheon-stable-position>
        </div>

        <spitfire-designer-question-hardware-lock
          title="Choose your Lock"
          :door-range="door.attr.door_range"
          :fabricator="fabricator"
          :frame-material="door.attr.frame_material"
          :hardware-escutcheon="door.attr.hardware_escutcheon"
          :hardware-handle="door.attr.hardware_handle"
          :hinge-side="door.attr.hinge_side"
          :opening_direction="door.attr.opening_direction"
          :secured-by-design="door.attr.secured_by_design"
          :slab="door.attr.slab"
          v-model:target="door.attr.hardware_lock"
          :modifier_class="'_wide'"
          component_id="hardware_lock"
        ></spitfire-designer-question-hardware-lock>

        <div v-show="technical_should_show">
            <designer-question-hardware-cylinder :door-range="door.attr.door_range"
                                                    :fabricator="fabricator"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :opening_direction="door.attr.opening_direction"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :slab="door.attr.slab"
                                                    v-model:target="door.attr.hardware_cylinder"
                                                    title="Choose Your Cylinder"></designer-question-hardware-cylinder>

            <designer-question-hardware-cylinder-stable :door-range="door.attr.door_range" :fabricator="fabricator"
                                                           :hardware-colour="door.attr.hardware_colour"
                                                           :hardware-cylinder="door.attr.hardware_cylinder"
                                                           :hardware-handle="door.attr.hardware_handle"
                                                           :hardware-lock="door.attr.hardware_lock"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :slab="door.attr.slab"
                                                           v-model:target="door.attr.hardware_cylinder_stable"
                                                           title="Stable Bottom Leaf Cylinder"
                                                           v-show="is_stable"></designer-question-hardware-cylinder-stable>

            <designer-question-hardware-cylinder-guard :fabricator="fabricator"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                       :hardware-cylinder="door.attr.hardware_cylinder"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       v-model:target="door.attr.hardware_cylinder_guard"></designer-question-hardware-cylinder-guard>

            <designer-question-hardware-key
              :fabricator="fabricator"
              title="Extra Key Type"
              v-model:target="door.attr.key"
              :hardware-cylinder="door.attr.hardware_cylinder"
            ></designer-question-hardware-key>

            <designer-question-hardware-key-qty
              :fabricator="fabricator"
              v-model:target="door.attr.key_qty"
              :keyAttribute="door.attr.key"
            ></designer-question-hardware-key-qty>
        </div>

        <div v-if="is_stable">
            <wb-designer-question-hardware-joining-bolt :door-range="door.attr.door_range"
                                                        :fabricator="fabricator"
                                                        :slab="door.attr.slab"
                                                        v-model:target="door.attr.hardware_joining_bolt"
                                                        title="Choose your Rack Bolt"></wb-designer-question-hardware-joining-bolt>

            <wb-designer-question-hardware-joining-bolt-position :door-range="door.attr.door_range"
                                                                 :fabricator="fabricator"
                                                                 :frame-material="door.attr.frame_material"
                                                                 :hardware-joining-bolt="door.attr.hardware_joining_bolt"
                                                                 :slab="door.attr.slab"
                                                                 v-model:target="door.attr.hardware_joining_bolt_pos"></wb-designer-question-hardware-joining-bolt-position>
        </div>

        <div>
            <wb-designer-question-hardware-letterbox :door-range="door.attr.door_range"
                                                     :fabricator="fabricator"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :side-panels="door.attr.side_panels"
                                                     :slab="door.attr.slab"
                                                     :hardware-suite="door.attr.suite"
                                                     v-model:target="door.attr.hardware_letterbox"></wb-designer-question-hardware-letterbox>

            <wb-designer-question-hardware-letterbox-position :door-range="door.attr.door_range"
                                                              :fabricator="fabricator"
                                                              :frame-id="door.attr.frame_style.frame_id"
                                                              :frame-material="door.attr.frame_material"
                                                              :hardware-letterbox="door.attr.hardware_letterbox"
                                                              :side-panels="door.attr.side_panels"
                                                              :slab="door.attr.slab"
                                                              v-model:target="door.attr.hardware_letterbox_pos"></wb-designer-question-hardware-letterbox-position>
        </div>

        <div v-if="!is_stable">
            <wb-designer-question-hardware-knocker :door-range="door.attr.door_range"
                                                   :fabricator="fabricator"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-spyhole="door.attr.hardware_spy_hole"
                                                     :slab="door.attr.slab"
                                                     :hardware-suite="door.attr.suite"
                                                   v-model:target="door.attr.hardware_knocker"></wb-designer-question-hardware-knocker>

            <wb-designer-question-hardware-knocker-position :door-range="door.attr.door_range"
                                                            :fabricator="fabricator"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-knocker="door.attr.hardware_knocker"
                                                            :slab="door.attr.slab"
                                                            v-model:target="door.attr.hardware_knocker_pos"></wb-designer-question-hardware-knocker-position>
        </div>

        <div>
            <wb-designer-question-hardware-spy-hole :door-range="door.attr.door_range"
                                                    :fabricator="fabricator"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :slab="door.attr.slab"
                                                    :hardware-suite="door.attr.suite"
                                                    v-model:target="door.attr.hardware_spy_hole"></wb-designer-question-hardware-spy-hole>

            <wb-designer-question-hardware-spy-hole-position :door-range="door.attr.door_range"
                                                             :fabricator="fabricator"
                                                             :frame-material="door.attr.frame_material"
                                                             :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                             :slab="door.attr.slab"
                                                             v-model:target="door.attr.hardware_spy_hole_pos"></wb-designer-question-hardware-spy-hole-position>
        </div>

        <div v-show="!is_firedoorrange && !is_stable">
            <wb-designer-question-hardware-security-chain :door-range="door.attr.door_range"
                                                          :fabricator="fabricator"
                                                          :hardware-colour="door.attr.hardware_colour"
                                                          :secured-by-design="door.attr.secured_by_design"
                                                          v-model:target="door.attr.hardware_security_chain"></wb-designer-question-hardware-security-chain>
        </div>

        <div class="designeroption" v-show="technical_should_show">
            <designer-question-hardware-numerals :fabricator="fabricator"
                                                 v-model:target="door.attr.numerals"
                                                 :slab="door.attr.slab"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :hardware-suite="door.attr.suite"
                                                 title="Numerals"></designer-question-hardware-numerals>
        </div>

        <div>
            <wb-designer-question-hardware-hinge :door-range="door.attr.door_range" :fabricator="fabricator"
                                                 :frame-material="door.attr.frame_material"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :hinge-side="door.attr.hinge_side"
                                                 :opening_direction="door.attr.opening_direction"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :slab="door.attr.slab"
                                                 v-model:target="door.attr.hardware_hinge"
            ></wb-designer-question-hardware-hinge>


        </div>

        <div class="designeroption hidden">
            <designer-question-hardware-hinge-bolts v-show="technical_should_show" :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_hinge_bolts"
                                                    :hardware-hinge="door.attr.hardware_hinge"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :title="'Dog Bolts: '"
            ></designer-question-hardware-hinge-bolts>
        </div>

        <div v-show="technical_should_show">
            <wb-designer-question-technical-profile :fabricator="fabricator"
                                                    :frame-colour-external="door.attr.frame_colour_external"
                                                    :frame-colour-internal="door.attr.frame_colour_internal"
                                                    :frame-material="door.attr.frame_material"
                                                    :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :opening-direction="door.attr.opening_direction"
                                                    v-model:target="door.attr.profile"></wb-designer-question-technical-profile>
        </div>

        <designer-question-slab-edge-profile-colour v-if="![136,137,138,150].includes(door.attr.door_range)"
                                                    :fabricator="fabricator"
                                                    v-model:target="door.attr.slab_edge_colour"
                                                    :colour-internal="door.attr.door_colour_internal"
                                                    :colour-external="door.attr.external_colour"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :profile="door.attr.profile"
                                                    :slab="door.attr.slab"
                                                    :door-range="door.attr.door_range"
                                                    :opening-direction="door.attr.opening_direction"
                                                    :maintitle="'Select Slab Edging Strip Colour'"
                                                    :extra_text="'Please note: Sprayed to match aluminium edging strips will extend the lead time and are not covered under warranty.'">
        </designer-question-slab-edge-profile-colour>

        <div>
            <wb-designer-question-addons :fabricator="fabricator"
                                         :frame-colour-external="door.attr.frame_colour_external"
                                         :frame-colour-internal="door.attr.frame_colour_internal"
                                         :frame-profile="door.attr.profile"
                                         v-model:target="door.attr.addons"
                                         v-show="technical_should_show"></wb-designer-question-addons>
        </div>

        <div>
            <wb-designer-question-technical-threshold :door-range="door.attr.door_range" :fabricator="fabricator"
                                                      :frame-colour-external="door.attr.frame_colour_external"
                                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                                      :frame-profile="door.attr.profile"
                                                      :opening-direction="door.attr.opening_direction"
                                                      v-model:target="door.attr.threshold"
                                                      title="Choose Your Threshold"
                                                      v-show="technical_should_show"></wb-designer-question-technical-threshold>

          <designer-question-sidepanel-threshold v-if="passed_filter_left && !is_firedoorrange" :fabricator="fabricator"
                                                 title="Choose Your Left Side Threshold"
                                                 v-model:target="door.attr.side_panels.left_threshold_id"
                                                 :frame-profile="door.attr.profile"
                                                 :threshold="door.attr.threshold"
                                                 :door-range="door.attr.door_range"></designer-question-sidepanel-threshold>

          <designer-question-sidepanel-threshold v-if="passed_filter_right && !is_firedoorrange" :fabricator="fabricator"
                                                 title="Choose Your Right Side Threshold"
                                                 v-model:target="door.attr.side_panels.right_threshold_id"
                                                 :frame-profile="door.attr.profile"
                                                 :threshold="door.attr.threshold"
                                                 :door-range="door.attr.door_range"></designer-question-sidepanel-threshold>

        </div>

        <div class="designeroption" data-designer-component-id="threshold_ramp" v-show="technical_should_show">
            <h3>Threshold Ramp</h3>

            <div class="stylesoption">
                <div class="row">
                    <div class="col">
                        <designer-question-technical-ramp title="External Ramp"
                                                          v-model:target="door.attr.ramp.external"
                                                          :fabricator="fabricator"
                                                          :profile="door.attr.profile"
                                                          :door-range="door.attr.door_range"
                                                          :threshold="door.attr.threshold">
                        </designer-question-technical-ramp>
                    </div>
                    <div class="col">
                        <designer-question-technical-ramp title="Internal Ramp"
                                                          v-model:target="door.attr.ramp.internal"
                                                          :fabricator="fabricator"
                                                          :profile="door.attr.profile"
                                                          :door-range="door.attr.door_range"
                                                          :threshold="door.attr.threshold">
                        </designer-question-technical-ramp>
                    </div>
                </div>
            </div>
        </div>

        <div class="designeroption" v-show="technical_should_show && !is_firedoorrange">
            <h3>Select Any Required Cills</h3>
            <designer-question-technical-cill :component_id="'cill'"
                                              :fabricator="fabricator"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-profile="door.attr.profile"
                                              :opening-direction="door.attr.opening_direction"
                                              v-model:target="door.attr.cill"
            ></designer-question-technical-cill>

            <designer-question-technical-cill :component_id="'left_cill'" :fabricator="fabricator"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-profile="door.attr.profile"
                                              v-model:target="door.attr.side_panels.left_sill_id"
                                              :title="'Left Sidepanel'"
                                              v-if="left_sill"
            ></designer-question-technical-cill>

            <designer-question-technical-cill :component_id="'right_cill'" :fabricator="fabricator"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-profile="door.attr.profile"
                                              v-model:target="door.attr.side_panels.right_sill_id"
                                              :title="'Right Sidepanel'"
                                              v-if="right_sill"
            ></designer-question-technical-cill>

            <designer-question-technical-cill :component_id="'left_flag_cill'" :fabricator="fabricator"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-profile="door.attr.profile"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :title="'Left Flag Sidepanel'"
                                              v-if="left_flag_sill"
            ></designer-question-technical-cill>

            <designer-question-technical-cill :component_id="'right_flag_cill'" :fabricator="fabricator"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-profile="door.attr.profile"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :title="'Right Flag Sidepanel'"
                                              v-if="right_flag_sill"
            ></designer-question-technical-cill>

        </div>

        <div>
            <wb-designer-question-door-drip-colour :external-colour="door.attr.external_colour" :fabricator="fabricator"
                                                   :frame-profile="door.attr.profile"
                                                   v-model:target="door.attr.door_drip_colour"
                                                   title="Choose A Door Drip colour"
                                                   v-show="false"></wb-designer-question-door-drip-colour>
        </div>

        <div v-if="is_stable">
            <div class="designeroption" data-designer-component-id="meeting_bar_style">
                <h3>Select Your Stable Meeting Styles</h3>
                <div class="stylesoption">
                    <div class="row">
                        <div class="col-md">
                            <designer-question-meeting-rail-colour
                                :fabricator="fabricator"
                                title="Bottom Meeting Style (Outside)"
                                :door-colour="door.attr.external_colour"
                                v-model:target="door.attr.meeting_bar_outside"
                                :frame-profile="door.attr.profile"
                            ></designer-question-meeting-rail-colour>
                        </div>
                        <div class="col-md">
                            <designer-question-meeting-rail-colour
                                :fabricator="fabricator"
                                title="Top Meeting Style (Inside)"
                                :door-colour="door.attr.door_colour_internal"
                                v-model:target="door.attr.meeting_bar_inside"
                                :frame-profile="door.attr.profile"
                                :meeting-rail-outside="door.attr.meeting_bar_outside"
                            ></designer-question-meeting-rail-colour>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <wb-designer-question-measurements :addons="door.attr.addons" :cill="door.attr.cill"
                                               :door-range="door.attr.door_range"
                                               :external-colour="door.attr.external_colour"
                                               :fabricator="fabricator"
                                               :frame-id="door.attr.frame_style.frame_id"
                                               :frame-profile="door.attr.profile"
                                               :hardware-handle="door.attr.hardware_handle"
                                               :hardware-hinge="door.attr.hardware_hinge"
                                               :hardware-knocker="door.attr.hardware_knocker"
                                               :hardware-escutcheon="door.attr.hardware_escutcheon"
                                               :hardware-letterbox="door.attr.hardware_letterbox"
                                               :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                               :hardware-lock="door.attr.hardware_lock"
                                               :hardware-spy-hole="door.attr.hardware_spy_hole"
                                               :internal-colour="door.attr.door_colour_internal"
                                               :side-panels="door.attr.side_panels"
                                               :slab="door.attr.slab"
                                               v-model:target="door.attr.measurements"
                                               :threshold="door.attr.threshold"
                                               title="Enter Your Required Measurements"
                                               :mdd="mdd"
                                               :technical_should_show="technical_should_show"
                                               v-show="technical_should_show"></wb-designer-question-measurements>
        </div>

        <div>
            <wb-designer-question-technical-drainage :cill="door.attr.cill" :fabricator="fabricator"
                                                     v-model:target="door.attr.drainage"
                                                     :threshold="door.attr.threshold"
                                                     v-show="technical_should_show"></wb-designer-question-technical-drainage>
        </div>

        <div class="designeroption" data-designer-component-id="reference" v-if="reference_on">
            <h3>Enter A Door Reference</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input class="form-control" dusk="door_reference" type="text" v-model="door.attr.reference">
                </div>
            </div>
        </div>
        <input class="form-control" dusk="door_reference" type="hidden" v-else v-model="door.attr.reference"
               value="Retail Door">

        <designer-question-notes v-model:target="door.attr.notes"></designer-question-notes>

      <designer-navigation
          v-if="show_navigation"
          :visible_designer_configurator_components="visible_designer_configurator_components"
          transition="designer-navigation"
      ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        computed: {
            is_firedoorrange() {
                return false;
            },
            no_sbd() {
                return this.is_french || this.is_stable;
            },
            is_french() {
                return this.door_type === 'french';
            },
            is_stable() {
                return this.door_type === 'stable';
            },
            left_sill() {
              if (this.left_flag_sill) {
                return false;
              }
              return this.door.attr.side_panels !== undefined && this.door.attr.frame_style.checkedPanels.indexOf('left') !== -1
            },
            right_sill() {
              if (this.right_flag_sill) {
                return false;
              }
              return this.door.attr.side_panels !== undefined && this.door.attr.frame_style.checkedPanels.indexOf('right') !== -1
            },
            passed_filter_left(){
              return this.door.attr.frame_material === 1 && this.door.attr.frame_style.checkedPanels.indexOf("left") !== -1;
            },
            passed_filter_right(){
              return this.door.attr.frame_material === 1 && this.door.attr.frame_style.checkedPanels.indexOf("right") !== -1;
            },
        },
        methods: {
            barbican_designer_side_banner_clicked() {
                swal({
                    title: 'Visit website',
                    text: 'Open site in new tab? Your design will not be lost',
                    type: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                }).then(() => {
                    window.open('https://www.barbicancompositedoors.com/', '_blank');
                }, function (dismiss) {
                    //
                });
            },
          defaults() {
            return {
              82: {
                "attr": {
                  "fabricator": 20,
                  "type": 1,
                  "door_range": 82,
                  "colour_range": 26,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "glass_design": 1,
                  "glass_text": "",
                  "hardware_colour": 22,
                  "hardware_handle": 363,
                  "hardware_hinge": 1336,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1068,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1897,
                  "hardware_cylinder": 3670,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "slab_edge_colour": 145627,
                  "profile": 145397,
                  "threshold": 145447,
                  "key": null,
                  "key_qty": 36,
                  "side_panels": {
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left": 1,
                    "right": 1,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "side_glass_text": {"text": "", "position": ""}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "couplers": {"sides": null, "top": null},
                  "hardware_hinge_bolts": 2012,
                  "suite": 8,
                  "hardware_decorative_handle": 1112,
                  "ramp": {"external": 144073, "internal": 144073},
                  "hardware_cylinder_stable": 450,
                  "hardware_handle_split_spindle": 424
                }
              },
              136: {
                "attr": {
                  "fabricator": 20,
                  "type": 12,
                  "door_range": 136,
                  "colour_range": 5,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "glass_design": 1,
                  "glass_text": "",
                  "hardware_colour": 22,
                  "hardware_handle": 363,
                  "hardware_hinge": 1336,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1218,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1897,
                  "hardware_cylinder": 3670,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 145397,
                  "threshold": 145447,
                  "key": null,
                  "key_qty": 36,
                  "side_panels": {
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left": 1,
                    "right": 1,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "side_glass_text": {"text": "", "position": ""}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "couplers": {"sides": null, "top": null},
                  "hardware_hinge_bolts": 2012,
                  "suite": 8,
                  "hardware_decorative_handle": 1112,
                  "ramp": {"external": 144073, "internal": 144073},
                  "hardware_cylinder_stable": 450,
                  "hardware_handle_split_spindle": 424
                }
              },
              137: {
                "attr": {
                  "fabricator": 20,
                  "type": 12,
                  "door_range": 137,
                  "colour_range": 5,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "glass_design": 1,
                  "glass_text": "",
                  "hardware_colour": 22,
                  "hardware_handle": 363,
                  "hardware_hinge": 1336,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1256,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1897,
                  "hardware_cylinder": 3670,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 145397,
                  "threshold": 145447,
                  "key": null,
                  "key_qty": 36,
                  "side_panels": {
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left": 1,
                    "right": 1,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "side_glass_text": {"text": "", "position": ""}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "couplers": {"sides": null, "top": null},
                  "hardware_hinge_bolts": 2012,
                  "suite": 8,
                  "hardware_decorative_handle": 1112,
                  "ramp": {"external": 144073, "internal": 144073},
                  "hardware_cylinder_stable": 450,
                  "hardware_handle_split_spindle": 424
                }
              },
              138: {
                "attr": {
                  "fabricator": 20,
                  "type": 12,
                  "door_range": 138,
                  "colour_range": 5,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "glass_design": 1,
                  "glass_text": "",
                  "hardware_colour": 22,
                  "hardware_handle": 363,
                  "hardware_hinge": 1336,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1356,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1897,
                  "hardware_cylinder": 3670,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 145397,
                  "threshold": 145447,
                  "key": null,
                  "key_qty": 36,
                  "side_panels": {
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left": 1,
                    "right": 1,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "side_glass_text": {"text": "", "position": ""}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "couplers": {"sides": null, "top": null},
                  "hardware_hinge_bolts": 2012,
                  "suite": 8,
                  "hardware_decorative_handle": 1112,
                  "ramp": {"external": 144073, "internal": 144073},
                  "hardware_cylinder_stable": 450,
                  "hardware_handle_split_spindle": 424
                }
              },
              139: {
                "attr": {
                  "fabricator": 20,
                  "type": 8,
                  "door_range": 139,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "glass_design": 1,
                  "glass_text": "",
                  "hardware_colour": 22,
                  "hardware_handle": 363,
                  "hardware_hinge": 1336,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1505,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1897,
                  "hardware_cylinder": 3670,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "slab_edge_colour": 145627,
                  "profile": 145397,
                  "threshold": 145447,
                  "key": null,
                  "key_qty": 36,
                  "side_panels": {
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left": 1,
                    "right": 1,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "side_glass_text": {"text": "", "position": ""}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "couplers": {"sides": null, "top": null},
                  "hardware_hinge_bolts": 2012,
                  "suite": 8,
                  "hardware_decorative_handle": 1112,
                  "ramp": {"external": 144073, "internal": 144073},
                  "hardware_cylinder_stable": 450,
                  "hardware_handle_split_spindle": 424
                }
              },
              140: {
                "attr": {
                  "fabricator": 20,
                  "type": 8,
                  "door_range": 140,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "glass_design": 1,
                  "glass_text": "",
                  "hardware_colour": 22,
                  "hardware_handle": 363,
                  "hardware_hinge": 1336,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1556,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1897,
                  "hardware_cylinder": 3670,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "slab_edge_colour": 145627,
                  "profile": 145397,
                  "threshold": 145447,
                  "key": null,
                  "key_qty": 36,
                  "side_panels": {
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left": 1,
                    "right": 1,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "side_glass_text": {"text": "", "position": ""}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "couplers": {"sides": null, "top": null},
                  "hardware_hinge_bolts": 2012,
                  "suite": 8,
                  "hardware_decorative_handle": 1112,
                  "ramp": {"external": 144073, "internal": 144073},
                  "hardware_cylinder_stable": 450,
                  "hardware_handle_split_spindle": 424
                }
              },
              141: {
                "attr": {
                  "fabricator": 20,
                  "type": 8,
                  "door_range": 141,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "glass_design": 1,
                  "glass_text": "",
                  "hardware_colour": 22,
                  "hardware_handle": 363,
                  "hardware_hinge": 1336,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1656,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1897,
                  "hardware_cylinder": 3670,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "slab_edge_colour": 145627,
                  "profile": 145397,
                  "threshold": 145447,
                  "key": null,
                  "key_qty": 36,
                  "side_panels": {
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left": 1,
                    "right": 1,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "side_glass_text": {"text": "", "position": ""}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "couplers": {"sides": null, "top": null},
                  "hardware_hinge_bolts": 2012,
                  "suite": 8,
                  "hardware_decorative_handle": 1112,
                  "ramp": {"external": 144073, "internal": 144073},
                  "hardware_cylinder_stable": 450,
                  "hardware_handle_split_spindle": 424
                }
              },
              150: {
                "attr": {
                  "fabricator": 20,
                  "type": 12,
                  "door_range": 150,
                  "colour_range": 5,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 1,
                  "external_colour": 1,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "glass_design": 1,
                  "glass_text": "",
                  "hardware_colour": 22,
                  "hardware_handle": 363,
                  "hardware_hinge": 1336,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1397,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1897,
                  "hardware_cylinder": 3670,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_spy_hole": 316,
                  "profile": 145397,
                  "threshold": 145447,
                  "key": null,
                  "key_qty": 36,
                  "side_panels": {
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "left": 1,
                    "right": 1,
                    "left_panel_glass_id": 19,
                    "right_panel_glass_id": 19,
                    "top_panel_glass_id": 19,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "side_glass_text": {"text": "", "position": ""}
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 149,
                  "drainage": 1,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "couplers": {"sides": null, "top": null},
                  "hardware_hinge_bolts": 2012,
                  "suite": 8,
                  "hardware_decorative_handle": 1112,
                  "ramp": {"external": 144073, "internal": 144073},
                  "hardware_cylinder_stable": 450,
                  "hardware_handle_split_spindle": 424,
                },
              },
            };
          },
        }
    }
</script>
